export const Field = ({ label, className = "", children }) => (
  <div className={className}>
    <label className="block font-tech text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-2">{label}</label>
    {children}
  </div>
);

export const PillGroup = ({ options, value, onChange, testidPrefix, dark = false }) => {
  const cls = (active) =>
    `px-4 py-2 rounded-full text-xs font-sub font-semibold uppercase tracking-wider border transition-colors duration-200 cursor-pointer ${
      active
        ? dark ? "bg-white text-black border-white" : "bg-[#0A0A0A] text-white border-[#0A0A0A]"
        : "bg-white text-zinc-600 border-zinc-300 hover:border-[#FF2A2A] hover:text-[#FF2A2A]"
    }`;
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((o) => (
        <button
          type="button"
          key={o}
          data-testid={`${testidPrefix}-${o.toLowerCase().replace(" ", "-")}`}
          onClick={() => onChange(o)}
          className={cls(value === o)}
        >
          {o}
        </button>
      ))}
    </div>
  );
};
